function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../../Icon/Icon';
import styles from './AsideMenu.module.sass';
import Chevron from '../../Chevron/Chevron';
import { useGlobalValue } from '../../../state/GlobalProvider';

const MobileMenuEntry = props => {
  const {
    item,
    children,
    expanded: expandedProp,
    onClick,
    childrenSize,
    level
  } = props;
  const {
    icon,
    name,
    badge,
    link,
    exact,
    funcOnClick
  } = item;
  const {
    uploadFiles
  } = useGlobalValue();
  const [expanded, setExpanded] = useState(expandedProp || false);
  const TagName = !link || children && children.length ? 'div' : NavLink;
  const elementAttributes = TagName === 'div' ? {} : {
    to: link || undefined,
    exact: exact,
    activeClassName: styles['is-selected']
  };
  const SPACING = 10;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TagName, _extends({
    className: `${styles['navigation-entry']} ${TagName === NavLink ? styles['has-link'] : ''}`,
    alt: name,
    style: {
      paddingLeft: level ? level * (20 + SPACING) : 0
    }
  }, elementAttributes, {
    onClick: TagName === 'div' ? () => {
      setExpanded(!expanded);
    } : funcOnClick ? eval(funcOnClick) : onClick
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['entry-details']
  }, /*#__PURE__*/React.createElement("div", null, icon && /*#__PURE__*/React.createElement(Icon, {
    className: styles['navigation-entry-icon'],
    name: icon
  }), /*#__PURE__*/React.createElement("small", {
    className: styles['navigation-entry-label']
  }, name)), !expanded && badge ? /*#__PURE__*/React.createElement("small", {
    className: styles['navigation-entry-badge']
  }, badge) : null), children && children.length ? /*#__PURE__*/React.createElement(Chevron, {
    direction: expanded ? 'down' : 'right',
    className: styles['chevron']
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: styles['inner-navigation'],
    style: {
      maxHeight: expanded ? (childrenSize || (children || []).length) * 44 : 0
    }
  }, children));
};

export default MobileMenuEntry;